/**
 * Check to see if an input value is a number.
 * Examples:
 * isNumeric(12345678912345678912); // true
 * isNumeric('2 ');                 // true
 * isNumeric('-32.2 ');             // true
 * isNumeric(-32.2);                // true
 * isNumeric(undefined);            // false
 * isNumeric('1a');                 // false
 *
 * @param value Input value to check if it is a number
 */
export const isNumeric = (value) => {
  const num = String(value); // coerce num to be a string
  return !isNaN(num as any) && !isNaN(parseFloat(num));
};
